/**
 * Scroll to node (consider sticky elements)
 *
 * It is recommended to call this method with requestAnimationFrame
 * if it's execution doesn't need to be in the same JS task.
 *
 * Ex. window.requestAnimationFrame(() => scrollToNode(node))
 */

export default function ScrollToNode(node) {
    const windowScrollY = window.scrollY
    const nodeMarginTop = parseInt(window.getComputedStyle(node).getPropertyValue('margin-top'))

    let scrollToY = node.offsetTop - nodeMarginTop


    // If present, segmented height when sticky on top
    const segmentedHeight = (function () {
        if (!document.querySelector('.segmented')) {
            return 0
        }
        return window.matchMedia("(min-width: 992px)").matches ? 64 : 0
    })()

    scrollToY = scrollToY - segmentedHeight

    // Nav height
    const navHeight = (function () {
        if (window.matchMedia("(min-width: 768px)").matches) {
            return 72
        }
        if (windowScrollY >= scrollToY - 56) {
            return 56
        }
        return 0
    })()

    scrollToY = scrollToY - navHeight

    scrollToY = scrollToY + 1 // Offset for subpixel

    window.scrollTo(0, scrollToY)
}